import * as React from 'react';
import styled from '../theme/styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: 40vh;
  ${media => media.theme.media.between('small', 'downMedium')`
    margin-top: ${props => props.theme.spacings.tiny};
    margin-bottom: ${props => props.theme.spacings.base};
  `}
  ${media => media.theme.media.greaterThan('large')`
    margin-top: ${props => props.theme.spacings.base};
    margin-bottom: ${props => props.theme.spacings.base};
  `}
`;

interface IProps {
  apiKey: string;
  query: string;
}

export const GoogleMaps = ({ apiKey, query }: IProps) => (
  <Wrapper>
    <iframe
      width="100%"
      height="100%"
      style={{ border: 0 }}
      src={`https://www.google.com/maps/embed/v1/place?key=${apiKey}
      &q=${encodeURIComponent(query)}`}
      allowFullScreen={true}
    />
  </Wrapper>
);
